import Vue from 'vue'
import Vuex from 'vuex'
// import { SET_USER_GMT, SET_USER_APP_ID } from './mutations-types'

import { userInfoTypes } from './modules/User'
import { BaseTypes } from './modules/Base'
import { cityInfoTypes } from './modules/NavCity'

Vue.use(Vuex)

interface IterRootSate {
  User: userInfoTypes;
  Base: BaseTypes;
  City: cityInfoTypes;
}

const store = new Vuex.Store<IterRootSate>({
  modules: { },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
